import _cloneDeep from 'lodash/cloneDeep';

export default class AdvancedController {
    $onInit() {
        if (!this.advancedInformation) {
            this.advancedInformation = {};
        }
    }

    $onChanges(changes) {
        if (changes.advancedInformation) {
            this.advancedInformation = _cloneDeep(changes.advancedInformation.currentValue);
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/advanced-information/advanced-information.controller.js